import { render, staticRenderFns } from "./MItemsPrice.vue?vue&type=template&id=291cfdf6&"
import script from "./MItemsPrice.vue?vue&type=script&lang=ts&"
export * from "./MItemsPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports